import { Link } from "react-router";
import { cn } from "@core/utils/domUtil";

export default function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("inline-flex items-center justify-center", className)}>
      <h1>
        <Link to="/" className="block h-[18px] w-[128px] bg-[url(@svg/header/logo.svg)] bg-size-[100%_auto] bg-center bg-no-repeat lg:h-[26px] lg:w-[183px]">
          <span className="visible-hidden">NC Family ZONE</span>
        </Link>
      </h1>
    </div>
  );
}
